import React from "react";
import Package from "../../../../package.json";
import { getAuthLoadingXmasStyle, getLoginLoadingBackdropStyle, isXMAS } from "./auth0Helpers";

const Auth0LoadingScreen = ({ theme, tryMsg }) => {
  const xmas = isXMAS();
  const isDark = theme !== "light";

  return (
    <div
      className={xmas ? "auth-page-xmas" : "auth-page"}
      style={xmas ? getAuthLoadingXmasStyle() : getLoginLoadingBackdropStyle(theme)}
    >
      <div className="auth-loading-root">
        <div className={`auth-loading-frame${isDark ? " auth-loading-frame--dark" : ""}`}>
          <div className="auth-loading-frame__rim" aria-hidden />
          <div className={`auth-loading-glass${isDark ? " auth-loading-glass--dark" : ""}`} role="status" aria-live="polite" aria-busy="true">
            <div className="auth-loading-logo">
              <img width={150} className="img-fluid" src={`/img/${isDark ? "logo_white.svg" : "logo_grey.svg"}`} alt="SalesPark" />
            </div>
            <div className="auth-loading-spinner" aria-hidden />
            <p className="auth-loading-status">{tryMsg}</p>
            <p className="auth-loading-version">v{Package?.version}</p>
            {xmas && <div className="auth-loading-xmas">🎄 Boas Festas 🎄</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth0LoadingScreen;
